import { CreateResponsiveStyle } from "rn-responsive-styles";

const useStyles = CreateResponsiveStyle(
  {
    container: {
      width: "60%",
      height: "80%",
      alignItems: "center",
      justifyContent: "center",
    },
    i_label: {
      width: "70%",
      height: "43%",
      zIndex: 1,
      position: "absolute",
      top: 0,
      right: "5.5%",
    },
    silverBar: {
      width: "100%",
      height: "100%",
    },
    silverText: {
      right: "10%",
      marginTop: "3.5%",
      color: "white",
      fontSize: 10,
      position: "absolute",
      fontFamily: "Roboto-Bold",
    },
  },
);

export default useStyles;
